import React from 'react'
import map from 'lodash/map'
import { useTableContext } from '@ztechapps/webui.data-tools'
import { useWorkOrderListContext } from './Context'
import { ExpandableWorkOrderRow } from './ExpandableWorkOrderRow'

export const WorkOrderTreeTableBody = () => {
  const { listResult } = useTableContext()
  const { workOrderList } = useWorkOrderListContext()
  const searchValue = workOrderList?.searchValue

  return (
    <tbody>
      {map(listResult?.list, (listItem, index) => (
        <ExpandableWorkOrderRow
          key={`${listItem?._id}_${index}`}
          listItem={listItem}
          index={index}
          level={0}
          searchValue={searchValue}
        />
      ))}
    </tbody>
  )
}
